import type { Response, CancelablePromise } from "@/api";
import { OpenAPI } from "@/api";
import { request as __request } from "../core/request";
import { FileDownloadRequest } from "@/api/models/file/FileDownloadRequest";

export class FileService {
  public static Upload(body?: { file: Blob }): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/file",
      formData: {
        file: body?.file,
      },
    });
  }

  public static async Download(body: FileDownloadRequest) {
    const blob = await __request<Blob>(OpenAPI, {
      method: "POST",
      url: "/file/download",
      body: body,
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    const contentDisposition = "File Transfer";
    let downloadFilename = body.filename;
    if (contentDisposition && contentDisposition.includes("filename=")) {
      downloadFilename = contentDisposition
        .split("filename=")[1]
        .replace(/['"]/g, "");
    }

    link.setAttribute("download", downloadFilename);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
}
